import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import PageHeader from "../../components/shared/PageHeader";
import PageMain from "../../containers/shared/PageMain";
import HelpCenterItem from "../../components/helpCenter/HelpCenterItem";

const HelpHomePage = () => {
    const {t,i18n} = useTranslation();
    useDocumentTitle('مركز المساعدة');
    const [userData, setUserData] = useState(null);
    const pageTitle = {title: 'مركز المساعدة', subTitle: 'يمكنك متابعة الاسئلة الشائعة واالتواصل مع الدعم'};


    const handleGetUser = (user) => {
        setUserData(user);
    }

    const helpCenterData = [
      {name: 'النظام',
        questions: [
          {
            question: 'ما هو فني بزنس؟',
            answer: 'فني بزنس هو نظام ذكي شامل إلدارة وصيانة المرافق مصمم لمساعدة المنشآت بمختلف القطاعات و الأحجام على تبسيط وتحسين عمليات إدارة و صيانة الأصول العقارية بفعالية و أقل تكلفة.'
          }
        ]
      },
      {name: 'مستخدمين فني بزنس',
        questions: [
          {
            question: 'من يمكنه استخدام فني بزنس؟',
            answer: 'فني بزنس مناسب للشركات التجارية من مختلف المجالات مثل البيع بالتجزئة، العقارات، التعليم، المطاعم ، المراكز التجارية ، وأيضا العقارات السكنية بكافة أنواعها و أحجامها.'
          },
          {
            question: 'هل فني بزنس مناسب للشركات متعددة المواقع؟',
            answer: 'نعم، فني بزنس مصمم لدعم المنشآت متعددة المواقع حول المملكة.'
          }
        ]
      },
      {name: 'المميزات والوظائف',
        questions: [
          {
            question: 'كيف يحسن فني بزنس إدارة مرافقك؟',
            answer: 'يتيح لك نظام فني بزنس طلب أعمال الصيانة بما يناسب احتياجك ، و القدرة على تتبع العمليات ، وجدولة الصيانة الوقائية، والوصول إىل تقارير مفصلة تمكنك من اتخاذ القرارات االستراتيجية المتعلقة بالتكاليف و الجودة.'
          },
          {
            question: 'ما أنواع الخدمات التي يمكن إدارتها باستخدام فني بزنس؟',
            answer: 'قدم فني بزنس حزمة متنوعة من خدمات و أعمال الصيانة تشمل صيانة أنظمة التكييف، الكهرباء، السباكة، صيانة المصاعد، األمن و السالمة ، التنظيف ومكافحة الحشرات، إدارة و تحليل األصول ، إدارة و تنظيم الموردين ، و غيرها.'
          },
          {
            question: 'ما أنواع التقارير التي يمكن أن يوفرها فني بزنس؟',
            answer: 'يوفر فني بزنس تقارير ذكية متخصصة كتقارير الصيانة الشهرية ، ملخص الآداء ، تحليل التكاليف، جداول الصيانة الوقائية و الطارئة، والتقارير التنبوئية.'
          },
          {
            question: 'ما هي اﻹشعارات الذكية وكيف تعمل؟',
            answer: 'اإلشعارات الذكية هي إشعارات تفاعلية تساعد بالتنبيه عن التحديثات الهامة، مواعيد الصيانة، و اإلجراءات الالزم اتخاذها من قبل المستخدمين.'
          }
        ]
      },
      {name: 'اﻷسعار',
        questions: [
          {
            question: 'كم تكلفة اﻹشتراك في فني بزنس؟',
            answer: 'قدم فني بزنس مجموعة متنوعة من الباقات اللتي تشمل مزايا خاصة و عدد وحدات يتناسب مع منشأتك و خيارات أكثر مرونة في إدارة تكاليف الصيانة السنوية بنموذج "الدفع حسب االستخدام".'
          },
          {
            question: 'هل يجب دفع رسوم شهرية لكل وحدة؟',
            answer: 'لا، يتم دفع رسوم سنوية فقط للوحدات؛ بينما يتم احتساب رسوم اشتراك شهرية للنظام حسب الباقة و الخدمات.'
          },
          {
            question: 'ما الفرق بين ترقية الباقة وإضافة وحدات إﱃ الباقة الحالية؟',
            answer: 'لترقية تمنحك مميزات إضافية ودعًما محّسًنا، بينما إضافة الوحدات تزيد من عدد الوحدات داخل مشنآتك إلدارتها ضمن الباقة الحالية.'
          }
        ]
      },
      {name: 'الباقات والتفعيل',
        questions: [
          {
            question: 'ما هي الباقات أو الخطط التي يقدمها فني بزنس؟',
            answer: 'خطط و باقات متنوعة تناسب احتياجات ، أحجام ، و قطاعات المنشآت المختلفة.'
          },
          {
            question: 'كيف يتم تفعيل الخطة؟',
            answer: 'يتم التفعيل والتجديد السنوي تلقائيا لضمان استمرار نظام إدارة مرافقك دون تدخل يدوي أو تعطيل.'
          }
        ]
      },
      {name: 'قطع الغيار و إدارة الموردين',
        questions: [
          {
            question: 'هل يمكنني العثور على المعدات الﻼزمة ﻻحتياجات الصيانة من خﻼل فني بزنس؟',
            answer: 'يمكن لجميع مستخدمي فني بزنس الحصول عىل المعدات و األدوات الالزمة ألعمال الصيانة من خالل متجر فني بشكل مباشر من المنصة.'
          }
        ]
      },
      {name: 'الكفاءة في التكاليف والتوفير',
        questions: [
          {
            question: 'كيف يمكن لفني بزنس أن يساعد في تقليل تكاليف الصيانة؟',
            answer: 'يساعدك فني بزنس عىل تحسين ميزانية الصيانة من خالل تنظيم طلبات الصيانة ، تقليل فترات التوقف ، االلتزام بمواعيد الصيانة الوقائية ، الفحص الدوري ، تحسين تخصيص الموارد ، و الحفاظ عىل جودة المرافق ألطول فترة ممكنة.'
          }
        ]
      }
    ];

  return (
    <div>
            <PageHeader pageTitle={pageTitle} userCallback={handleGetUser} />
            <PageMain>
              <div className="py-[32px]">
                <div className="absolute top-0 left-0 w-full h-full bg-grey-50 z-0"></div>
                <div className="flex flex-nowrap gap-[15px]">
                  <div className="w-[calc(100%-323px)]">
                    <div className="relative rounded-[12px] bg-white p-[24px]">
                      {helpCenterData && Array.isArray(helpCenterData) && helpCenterData?.length > 0 
                      ? helpCenterData?.map((item,index)=><HelpCenterItem key={`helpCenterItem-${index}`} item={item} />)
                      :<div className="text-center font-bold text-blue text-[18px] cairo-font">لاتوجد اسئلة بعد.</div>}
                    </div>
                  </div>
                  <div className="w-[323px]">
                    <div className="p-[16px] rounded-[16px] relative z-[1]" style={{background: 'linear-gradient(180deg, #C3E1FF 0%, #F4F8FE 100%)'}}>
                        <h3 className="cairo-font text-center font-[700] text-[24px] text-darkBlue mb-[10px]">التواصل معنا</h3>
                        <p className="cairo-font font-[500] text-[18px] text-grey-900 pb-[5px] border-b-[1px] border-b-blue pe-[30px]">اذا لم تجد ما يفيد استفسارك يمكنك التواصل معنا عبر</p>
                        <p className="cairo-font text-grey-900 text-[16px] py-[10px] border-b-[1px] border-b-blue">
                          <span className="w-[20px] h-[20px] inline-block align-middle me-[5px]" style={{ background: "url('/assets/images/mobile.svg') center no-repeat"}}></span>
                          <span className="font-bold cairo-font inline-block align-middle me-[5px]">الجوال</span>
                          <span className="cairo-font" dir="ltr">+920031015</span>
                        </p>
                        <p className="cairo-font text-grey-900 text-[16px] py-[10px] border-b-[1px] border-b-blue">
                          <span className="w-[20px] h-[20px] inline-block align-middle me-[5px]" style={{ background: "url('/assets/images/sms.svg') center no-repeat"}}></span>
                          <span className="font-bold cairo-font inline-block align-middle me-[5px]">البريد الإلكتروني</span>
                          <span className="cairo-font" dir="ltr">Business@fanni.sa</span>
                        </p>
                        {/* <p className="cairo-font text-center text-grey-900 font-[500] text-[18px] pt-[15px]">تواصل مع مدير حسابك</p> */}
                        <Link to={'mailto:moruj@fanni.sa'} className="bg-darkBlue rounded-[8px] font-[600] text-[18px] text-white text-center h-[48px] leading-[48px] block cursor-pointer select-none mt-[15px] mb-[10px]">
                          {/* <span className="inline-block align-middle h-[20px] w-[20px] me-[10px]" style={{background: "url('/assets/images/whatsapp.svg') center no-repeat"}}></span> */}
                          تواصل مع مدير حسابك
                        </Link>
                    </div>
                  </div>
                </div>
              </div>
            </PageMain>
    </div>
  );
};

export default HelpHomePage;
